module.exports = __webpack_public_path__ + "static/media/service-location.30c38934.png";